// Mock data extracted from OptimizeHub.js to reduce component size

// Fallback flat layers structure (demo data)
export const mockModelLayers = [
  { id: 'conv1', name: 'Conv2d_1', type: 'Conv2d', latency: 0.15, params: '9.4K', flops: '118M', status: 'unoptimized', speedup: 1.0 },
  { id: 'bn1', name: 'BatchNorm2d_1', type: 'BatchNorm2d', latency: 0.01, params: '128', flops: '3.2M', status: 'unoptimized', speedup: 1.0 },
  { id: 'input', name: 'Input', type: 'Input', latency: 0.00, params: '0', flops: '0', status: 'optimized', speedup: 2.8 },
  { id: 'conv2d_1', name: 'Conv2D_1', type: 'Conv2D', latency: 0.12, params: '9.4K', flops: '118M', status: 'optimized', speedup: 2.8 },
  { id: 'batchnorm_1', name: 'BatchNorm_1', type: 'BatchNorm', latency: 0.03, params: '128', flops: '12M', status: 'optimized', speedup: 2.8 },
  { id: 'relu_1', name: 'ReLU_1', type: 'ReLU', latency: 0.01, params: '0', flops: '12M', status: 'optimized', speedup: 2.8 },
  { id: 'conv2_1', name: 'Conv2D_2_1', type: 'Conv2D', latency: 0.45, params: '73K', flops: '924M', status: 'candidate', speedup: 1.4 },
  { id: 'bn2_1', name: 'BatchNorm_2_1', type: 'BatchNorm', latency: 0.05, params: '256', flops: '6M', status: 'candidate', speedup: 1.4 },
  { id: 'relu2_1', name: 'ReLU_2_1', type: 'ReLU', latency: 0.02, params: '0', flops: '6M', status: 'candidate', speedup: 1.4 },
  { id: 'conv2_2', name: 'Conv2D_2_2', type: 'Conv2D', latency: 0.67, params: '147K', flops: '462M', status: 'candidate', speedup: 1.4 },
  { id: 'bn2_2', name: 'BatchNorm_2_2', type: 'BatchNorm', latency: 0.04, params: '256', flops: '3M', status: 'candidate', speedup: 1.4 },
  { id: 'add1', name: 'Add_1', type: 'Add', latency: 0.02, params: '0', flops: '3M', status: 'candidate', speedup: 1.4 },
  { id: 'conv3_1', name: 'Conv2D_3_1', type: 'Conv2D', latency: 0.28, params: '294K', flops: '231M', status: 'optimized', speedup: 3.2 },
  { id: 'bn3_1', name: 'BatchNorm_3_1', type: 'BatchNorm', latency: 0.03, params: '512', flops: '1.5M', status: 'optimized', speedup: 3.2 },
  { id: 'relu3_1', name: 'ReLU_3_1', type: 'ReLU', latency: 0.01, params: '0', flops: '1.5M', status: 'optimized', speedup: 3.2 },
  { id: 'conv3_2', name: 'Conv2D_3_2', type: 'Conv2D', latency: 0.52, params: '589K', flops: '115M', status: 'optimized', speedup: 3.2 },
  { id: 'bn3_2', name: 'BatchNorm_3_2', type: 'BatchNorm', latency: 0.03, params: '512', flops: '0.8M', status: 'optimized', speedup: 3.2 },
  { id: 'add2', name: 'Add_2', type: 'Add', latency: 0.02, params: '0', flops: '0.8M', status: 'optimized', speedup: 3.2 },
  { id: 'layernorm1', name: 'LayerNorm_1', type: 'LayerNorm', latency: 0.02, params: '1K', flops: '0.5M', status: 'optimized', speedup: 8.7 },
  { id: 'attention', name: 'MultiHeadAttention', type: 'Attention', latency: 0.15, params: '2.3M', flops: '45M', status: 'optimized', speedup: 8.7 },
  { id: 'dropout1', name: 'Dropout_1', type: 'Dropout', latency: 0.01, params: '0', flops: '0', status: 'optimized', speedup: 8.7 },
  { id: 'pool', name: 'GlobalAvgPool', type: 'GlobalPool', latency: 0.02, params: '0', flops: '0.1M', status: 'unoptimized', speedup: 1.0 },
  { id: 'dropout2', name: 'Dropout_2', type: 'Dropout', latency: 0.01, params: '0', flops: '0', status: 'unoptimized', speedup: 1.0 },
  { id: 'fc', name: 'Dense_1', type: 'Dense', latency: 1.23, params: '513K', flops: '1M', status: 'unoptimized', speedup: 1.0 },
  { id: 'softmax', name: 'Softmax', type: 'Softmax', latency: 0.02, params: '0', flops: '2K', status: 'unoptimized', speedup: 1.0 }
];

// Mock revision data for optimization history
export const mockRevisions = [
  {
    id: 'rev_1',
    version: 'v1.0.0',
    timestamp: '2024-09-01 10:00:00',
    author: 'initial_commit',
    branch: 'main',
    message: 'Initial ResNet50 baseline implementation',
    performance: { latency: 19.8, throughput: 505, speedup: 1.0 },
    layersModified: ['Conv2d_1', 'BatchNorm2d_1', 'Conv2D_1', 'BatchNorm_1', 'ReLU_1'],
    layersMerged: [],
    layersRemoved: [],
    changeType: 'baseline',
    diffStats: { additions: 450, deletions: 0, files: 8 },
    details: {
      description: 'Initial PyTorch implementation of ResNet50 with standard layers. Establishes baseline performance metrics.',
      keyChanges: [
        'Basic Conv2D implementations using PyTorch defaults',
        'Standard BatchNorm and ReLU activations',
        'Dense layer for classification',
        'No optimization techniques applied'
      ],
      codeChanges: `+ class ResNet50(nn.Module):
+     def __init__(self, num_classes=1000):
+         super(ResNet50, self).__init__()
+         self.conv1 = nn.Conv2d(3, 64, 7, 2, 3, bias=False)
+         self.bn1 = nn.BatchNorm2d(64)
+         self.relu = nn.ReLU(inplace=True)
+         # ... rest of network`,
      impactAnalysis: 'Establishes the performance baseline that all future optimizations will be measured against.'
    }
  },
  {
    id: 'rev_67',
    version: 'v1.5.1',
    timestamp: '2024-09-12 11:20:45',
    author: 'tensor_hacker',
    branch: 'main',
    message: 'Enable TensorCore operations for all Conv2D layers',
    performance: { latency: 5.8, throughput: 1724, speedup: 3.4 },
    layersModified: ['Conv2D_2_1', 'BatchNorm_2_1', 'ReLU_2_1', 'Conv2D_2_2'],
    layersMerged: [],
    layersRemoved: [],
    changeType: 'optimization',
    diffStats: { additions: 156, deletions: 23, files: 5 },
    details: {
      description: 'First major optimization enabling TensorCore acceleration across all convolution layers.',
      keyChanges: [
        'Convert all Conv2D layers to FP16 precision',
        'Implement WMMA (Warp Matrix Multiply Accumulate) operations',
        'Custom CUDA kernels for TensorCore utilization',
        'Mixed precision training integration'
      ],
      codeChanges: `- __global__ void conv2d_fp32_kernel(const float* input, const float* weights, float* output)
+ __global__ void conv2d_tensorcore_kernel(const half* input, const half* weights, half* output)
+
+ // Declare fragments for TensorCore
+ wmma::fragment<wmma::matrix_a, 16, 16, 16, half, wmma::row_major> a_frag;
+ wmma::fragment<wmma::matrix_b, 16, 16, 16, half, wmma::col_major> b_frag;
+ wmma::fragment<wmma::accumulator, 16, 16, 16, half> c_frag;`,
      impactAnalysis: 'Achieves 3.4x speedup by leveraging specialized Tensor units. Sets foundation for future optimizations.'
    }
  },
  {
    id: 'rev_89',
    version: 'v1.6.2',
    timestamp: '2024-09-15 16:45:12',
    author: 'gpu_wizard',
    branch: 'main',
    message: 'Optimize Attention mechanism with FlashAttention-2',
    performance: { latency: 4.1, throughput: 2439, speedup: 4.8 },
    layersModified: ['MultiHeadAttention'],
    layersMerged: [['LayerNorm_1', 'MultiHeadAttention']],
    layersRemoved: ['Dropout_1'],
    changeType: 'algorithm',
    diffStats: { additions: 245, deletions: 123, files: 9 },
    details: {
      description: 'Revolutionary attention optimization reducing memory usage and improving computational efficiency.',
      keyChanges: [
        'FlashAttention-2 algorithm implementation',
        'Tiled computation with online softmax',
        'Reduced HBM memory access patterns',
        'Fused attention kernels'
      ],
      codeChanges: `- // Standard attention implementation
- float* attention_weights = (float*)malloc(seq_len * seq_len * sizeof(float));
-
+ // FlashAttention-2 implementation
+ __global__ void flash_attention_v2_kernel(const half* Q, const half* K, const half* V, half* output) {
+     __shared__ half Q_tile[TILE_SIZE][HEAD_DIM];
+     __shared__ half K_tile[TILE_SIZE][HEAD_DIM];
+
+     float row_max = -INFINITY;
+     float row_sum = 0.0f;
+     // Tiled computation with online softmax
+ }`,
      impactAnalysis: 'Breakthrough in attention efficiency. Reduces memory from O(n²) to O(n) while maintaining accuracy.'
    }
  },
  {
    id: 'rev_112',
    version: 'v1.7.8',
    timestamp: '2024-09-18 09:15:33',
    author: 'perf_master',
    branch: 'main',
    message: 'Create fused Conv+BN+ReLU kernel for Residual Block 1',
    performance: { latency: 3.2, throughput: 3125, speedup: 6.2 },
    layersModified: ['Conv2D_2_1', 'BatchNorm_2_1'],
    layersMerged: [['Conv2D_2_1', 'BatchNorm_2_1', 'ReLU_2_1']],
    layersRemoved: [],
    changeType: 'fusion',
    diffStats: { additions: 203, deletions: 67, files: 8 },
    details: {
      description: 'Kernel fusion optimization eliminating intermediate memory transfers in residual blocks.',
      keyChanges: [
        'Fused Conv+BatchNorm+ReLU operations',
        'Single kernel launch instead of three separate calls',
        'Reduced memory bandwidth requirements',
        'Register-level intermediate value storage'
      ],
      codeChanges: `- // Separate kernel launches
- conv2d_kernel<<<grid1, block1>>>(input, conv_weights, conv_output);
- cudaDeviceSynchronize();
- batch_norm_kernel<<<grid2, block2>>>(conv_output, bn_weights, bn_output);
- cudaDeviceSynchronize();
- relu_kernel<<<grid3, block3>>>(bn_output, final_output);
+
+ // Single fused kernel launch
+ __global__ void fused_conv_bn_relu_kernel(
+     const float* input, const float* conv_weights,
+     const float* bn_weights, const float* bn_bias, float* output) {
+
+     // Compute convolution in registers
+     float conv_result = 0.0f;
+     // Apply batch norm inline
+     float bn_result = (conv_result - bn_mean) * bn_scale + bn_bias;
+     // Apply ReLU inline
+     output[idx] = fmaxf(0.0f, bn_result);
+ }`,
      impactAnalysis: 'Eliminates memory round trips between kernels. Provides 6.2x overall speedup through operation fusion.'
    }
  },
  {
    id: 'rev_134',
    version: 'v1.8.3',
    timestamp: '2024-09-20 14:30:22',
    author: 'cuda_ninja',
    branch: 'main',
    message: 'Implement Winograd + TensorCore fusion for Conv2D_1',
    performance: { latency: 2.4, throughput: 4167, speedup: 8.3 },
    layersModified: ['Conv2d_1', 'BatchNorm2d_1'],
    layersMerged: [['Conv2D_1', 'ReLU_1']],
    layersRemoved: [],
    changeType: 'optimization',
    diffStats: { additions: 89, deletions: 34, files: 3 },
    details: {
      description: 'Major breakthrough replacing standard GEMM with Winograd algorithm combined with TensorCore acceleration.',
      keyChanges: [
        'Winograd F(2,3) transform for 3x3 convolutions',
        'TensorCore WMMA operations for 16x16 matrix tiles',
        'FP16 precision with mixed-precision training',
        'Custom CUDA kernel implementation'
      ],
      codeChanges: `- __global__ void conv2d_gemm_kernel(float* input, float* weights, float* output)
+ __global__ void conv2d_winograd_tc_kernel(const half* input, const half* weights, half* output)
+
+ // Winograd transformation matrices
+ const float B[4][4] = {{1,0,-1,0}, {0,1,1,0}, {0,-1,1,0}, {0,1,0,-1}};
+
+ // Transform input tile: B^T * d * B
+ wmma::fragment<wmma::matrix_a, 16, 16, 16, half, wmma::row_major> a_frag;
+ wmma::load_matrix_sync(a_frag, winograd_input, 16);
+ wmma::mma_sync(c_frag, a_frag, b_frag, c_frag);`,
      impactAnalysis: 'Reduced Conv2D_1 latency from 0.38ms to 0.089ms. First major algorithmic breakthrough.'
    }
  },
  {
    id: 'rev_1420',
    version: 'v2.1.1',
    timestamp: '2024-09-21 13:22:17',
    author: 'gpu_wizard',
    branch: 'experimental/quantization',
    message: 'INT4 quantization with CUTLASS 3.0 kernels',
    performance: { latency: 2.2, throughput: 4545, speedup: 9.0 },
    layersModified: ['Conv2D_2_1', 'BatchNorm_2_1', 'ReLU_2_1', 'Conv2D_2_2'],
    layersMerged: [['Conv2D_1', 'BatchNorm_1'], ['Conv2D_2_1', 'BatchNorm_2_1'], ['Conv2D_3_1', 'BatchNorm_3_1']],
    layersRemoved: [],
    changeType: 'optimization',
    diffStats: { additions: 287, deletions: 45, files: 12 },
    details: {
      description: 'Aggressive quantization to INT4 precision using state-of-the-art CUTLASS templates.',
      keyChanges: [
        'INT4 weight quantization with calibration',
        'CUTLASS 3.0 templated kernels',
        'Dynamic activation scaling',
        'Quantization-aware training integration'
      ],
      codeChanges: `+ #include <cutlass/gemm/device/gemm.h>
+ using Gemm = cutlass::gemm::device::Gemm<
+     cutlass::int4b_t,  // ElementA
+     cutlass::layout::RowMajor,
+     cutlass::int4b_t,  // ElementB
+     cutlass::layout::ColumnMajor,
+     cutlass::half_t,   // ElementC
+     cutlass::layout::RowMajor>;
+
+ // Calibration for quantization
+ void calibrate_int4_weights(const float* fp32_weights, int4b_t* quantized_weights) {
+     // Dynamic range calibration
+ }`,
      impactAnalysis: 'Maintains accuracy while reducing model size by 4x. Requires specialized quantization kernels.'
    }
  },
  {
    id: 'rev_1431',
    version: 'v2.1.4',
    timestamp: '2024-09-22 11:30:22',
    author: 'cuda_ninja',
    branch: 'main',
    message: 'Implement FlashAttention-3 with ring attention pattern',
    performance: { latency: 1.8, throughput: 5556, speedup: 11.0 },
    layersModified: ['MultiHeadAttention'],
    layersMerged: [['LayerNorm_1', 'MultiHeadAttention']],
    layersRemoved: ['Dropout_1'],
    changeType: 'algorithm',
    diffStats: { additions: 89, deletions: 34, files: 3 },
    details: {
      description: 'Latest FlashAttention-3 algorithm with ring attention for distributed sequences.',
      keyChanges: [
        'FlashAttention-3 with improved memory efficiency',
        'Ring attention pattern for long sequences',
        'Fused attention + layer norm kernel',
        'Block-sparse attention patterns'
      ],
      codeChanges: `+ __global__ void flash_attention_v3_ring_kernel(
+     const half* Q, const half* K, const half* V,
+     half* output, int ring_size) {
+
+     // Ring attention with improved tiling
+     __shared__ half Q_shared[TILE_SIZE][HEAD_DIM];
+     __shared__ half K_shared[TILE_SIZE][HEAD_DIM];
+
+     // Process attention in rings for memory efficiency
+     for (int ring_idx = 0; ring_idx < ring_size; ring_idx++) {
+         // Rotate K and V through rings
+         // Compute partial attention scores
+     }
+ }`,
      impactAnalysis: 'Breakthrough in attention efficiency. Enables longer sequences with sub-quadratic memory usage.'
    }
  }
];

// Leaderboard data for global benchmark
export const mockLeaderboardData = [
  // Empty - will be populated with real data from API
];

// Model layer nodes for revision visualization
export const mockVisualizationNodes = [
  { id: 'input_block', name: 'Input Processing', x: 50, y: 100, status: 'optimized' },
  { id: 'res_block_1', name: 'ResBlock 1', x: 200, y: 80, status: 'optimized' },
  { id: 'res_block_2', name: 'ResBlock 2', x: 200, y: 120, status: 'optimized' },
  { id: 'attention_block', name: 'Attention', x: 350, y: 100, status: 'optimized' },
  { id: 'output_block', name: 'Output', x: 500, y: 100, status: 'candidate' }
];

// Mock model metrics for fallback data
export const mockModelMetrics = {
  totalLayers: 25,
  totalLatency: 4.2,
  totalParameters: 25000000,
  averageLatency: 0.17,
  modelSize: '98MB',
  status: 'demo'
};